import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function EmergencyPlanPostRescueNotificationSection({ section, sectionNumber = 3 }) {
  const data = section && section.data ? section.data : {};
  const displayName = section && section.display_name ? section.display_name : "Post-Rescue Notification";
  const items = Array.isArray(data.items)
    ? data.items.filter((item) => (
      item
      && [item.action, item.timing, item.owner]
        .some((value) => String(value || "").trim() !== "")
    ))
    : [];

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`} style={{ background: "#e9c84a", color: "#1f1031" }}>
          {sectionNumber}
        </span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        <table className={`${styles.PreviewTable} ${styles.EmergencyPlanScenarioTable}`}>
          <colgroup>
            <col style={{ width: "45%" }} />
            <col style={{ width: "25%" }} />
            <col style={{ width: "30%" }} />
          </colgroup>
          <thead className={styles.EmergencyPlanScenarioTableHead}>
            <tr>
              <th>Action</th>
              <th>Owner</th>
              <th>Timing / Requirement</th>
            </tr>
          </thead>
          <tbody>
            {items.length > 0 ? items.map((item, index) => (
              <tr key={item.id || index}>
                <td>{item.action || ""}</td>
                <td>{item.owner || ""}</td>
                <td>{item.timing || ""}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan={3}>No post-rescue notifications available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
